import axios from 'axios';
import { company, API } from '../../config';

const SPORTSBOOK_SM_TERMINAL_ID = '1fbc3bdc816bf8782d125f9523f37a6d';

const languageMapper = {
  'sr-latn': 'sr',
  'mk-latn': 'mk',
};

export default {
  getUrl() {
    const locale = company.locale ? company.locale.toLocaleLowerCase() : company.locale;
    const mappedLanguage = languageMapper[locale] || locale;

    const projectsLocale = `${API.tc}/translations/${SPORTSBOOK_SM_TERMINAL_ID}/locales/${mappedLanguage}`;
    const tenantLocale = company.uuid ? `${projectsLocale}/tenants/${company.uuid}` : projectsLocale;

    return `${tenantLocale}?includeLocaleFallback=true`;
  },
  fetch() {
    const url = this.getUrl();
    return axios.get(url).then(res => res.data).catch();
  },
};
